const DAILY_SUMMARY_CUTOVER_HOUR = 17
const DAILY_SUMMARY_CUTOVER_MINUTE = 30

export function createDefaultTeamWorkbenchStatusFilter(now = new Date()) {
  const hour = Number(now?.getHours?.())
  const minute = Number(now?.getMinutes?.())
  const beforeSummaryCutover = hour < DAILY_SUMMARY_CUTOVER_HOUR
    || (hour === DAILY_SUMMARY_CUTOVER_HOUR && minute < DAILY_SUMMARY_CUTOVER_MINUTE)

  if (beforeSummaryCutover) {
    return { planStatus: 'SUBMITTED', summaryStatus: '' }
  }
  return { planStatus: '', summaryStatus: 'SUBMITTED' }
}
